import React, { Fragment, useRef, useState } from "react"
import { Link } from "react-router-dom"
import {
    Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Label, Row, Input
} from "reactstrap"
import { accessRole } from "../../../../helpers/access_role"
import Select from "../../../../helpers/ui/CustomSelect"
import TableActiveComponent from './Components/TablePrimaryComponent'

const statusPengajuanWfh = [
    { value: 0, label: 'Menunggu Persetujuan Admin' },
    { value: 1, label: 'Pengajuan Disetujui' },
    { value: 2, label: 'Menunggu Persetujuan Laporan' },
    { value: 3, label: 'Selesai' },
    { value: 4, label: 'Persetujuan Disetujui Sebagian' },
]

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const [status, setStatus] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [filter, setFilter] = useState()
    const activeRef = useRef();
    const inactiveRef = useRef();

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const handleButtonSearch = () => {
        let params = {}
        if (status !== null) {
            params.status = status
        }
        if (startDate) {
            params.startDate = startDate
        }
        if (endDate) {
            params.endDate = endDate
        }
        
        setFilter(params)
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    <Button color="primary" onClick={()=>reloadActiveRef()}>Load Data</Button>
                                    &nbsp;&nbsp;
                                    <Link to="?createadmin">
                                        <Button color="primary" onClick={()=>reloadActiveRef()}>Tambah Pengajuan WFH</Button>
                                    </Link>
                                </div>
                                <CardTitle>Daftar Pengajuan WFH</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Pengajuan WFH
                                </CardSubtitle>
                                <hr />
                                <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Status Pengajuan WFH
                                    </Label>
                                    <Col md="3">
                                        <Select options={statusPengajuanWfh} isAvForm={false} isClearable={true} onChange={opt => setStatus(opt ? opt.value : null)} />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Tanggal Awal
                                    </Label>
                                    <Col md="3">
                                        <Input type="date" onChange={e => setStartDate(e.target.value)} />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Label className="col-md-3 col-form-label">
                                        Tanggal Akhir
                                    </Label>
                                    <Col md="3">
                                        <Input type="date" onChange={e => setEndDate(e.target.value)} />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="10">
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                    </Col>
                                </Row>
                                
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} filter={filter}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView